// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"2781c119","492":"60c0f033","640":"a02ff798","647":"56af2fcf","993":"81dafa70"}[chunkId] + ".chunk.js";
};